import { ApiClientError } from '~/ApiClient';
import { CroatiaMaxPriceThirdPriceDeviationResponse } from 'com.cogvio.pricemonitor.api';

import { FinalCalculation } from './FinalCalculation';
import { mapComparativePrice, RawComparativePrice } from './mapComparativePrice';
import { mapError } from './mapError';
import { mapReferencedProduct, RawReferencedProduct } from './mapReferencedProduct';
import { mapThirdPriceDeviation } from './mapThirdPriceDeviation';

export interface RawFinalCalculation {
	readonly comparativePrice: RawComparativePrice | null;
	readonly thirdPriceDeviation: CroatiaMaxPriceThirdPriceDeviationResponse | null;
	readonly potentialPriceDropPercents: number;
	readonly referencedProduct: RawReferencedProduct | null;
	readonly emptyResultReason: ApiClientError[];
}

export const mapFinalCalculation = (finalCalculation: RawFinalCalculation) =>
	new FinalCalculation(
		finalCalculation.comparativePrice !== null ? mapComparativePrice(finalCalculation.comparativePrice) : null,
		finalCalculation.thirdPriceDeviation !== null ? mapThirdPriceDeviation(finalCalculation.thirdPriceDeviation) : null,
		finalCalculation.potentialPriceDropPercents,
		finalCalculation.referencedProduct !== null ? mapReferencedProduct(finalCalculation.referencedProduct) : null,
		finalCalculation.emptyResultReason.map(mapError)
	);
